/* Nysha Jewels: mobile-only behaviour (runs once on load, phones only). Styles live in nysha-mobile-fixes.css. */
(() => {
  if (!window.matchMedia('(max-width: 767px)').matches) return;

  // ---- Trust strip: duplicate the items once so the CSS marquee loops without a jump
  document.querySelectorAll('.section-features .section__list').forEach((list) => {
    if (list.hasAttribute('data-marquee')) return;

    [...list.children].forEach((item) => {
      const copy = item.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      list.appendChild(copy);
    });

    list.setAttribute('data-marquee', '');
  });

  // ---- Footer signup: reuse the wording of the "Subscribe & Shine" banner (hidden on mobile by CSS)
  const banner = document.querySelector('.newsletter-banner');
  const signup = document.querySelector('.footer .newsletter');

  if (banner && signup) {
    const title = banner.querySelector('.newsletter__title');
    const subtitle = banner.querySelector('.newsletter__subtitle');
    const heading = signup.querySelector('.newsletter__heading');
    const text = [...signup.querySelectorAll(':scope > p')].find(
      (p) => !p.classList.contains('newsletter__policy') && p.textContent.trim()
    );

    if (title && heading) heading.textContent = title.textContent.trim();
    if (subtitle && text) text.textContent = subtitle.textContent.trim();
  }

  // ---- Header search icon: open the mobile menu drawer and focus its (working) search field
  const searchIcon = document.querySelector('.header__search-icon');
  const drawerButton = document.querySelector('.header-mobile__button');

  if (searchIcon && drawerButton) {
    searchIcon.addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();

        if (!document.querySelector('header-mobile-drawer[active]')) {
          drawerButton.click();
        }

        setTimeout(() => {
          document.querySelector('.header-mobile__search input[type="search"]')?.focus();
        }, 400);
      },
      true
    );
  }

  // ---- "Our Promise": collapse the long text behind a Read more button
  const promise = document.querySelector(
    '[class*="section-richtext--template"][class*="60f66916-dd20-4f8b-9024-8bf6b44d0977"] .section__entry'
  );

  if (promise && promise.scrollHeight > 220) {
    promise.classList.add('nysha-clamp');

    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'nysha-readmore';
    toggle.textContent = 'Read more';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.addEventListener('click', () => {
      const open = promise.classList.toggle('is-open');
      toggle.textContent = open ? 'Read less' : 'Read more';
      toggle.setAttribute('aria-expanded', String(open));
    });

    promise.insertAdjacentElement('afterend', toggle);
  }

  // ---- Product page: trust row under the buy buttons + sticky add to cart bar
  const form = document.querySelector('form.product__form[id$="__main"]');
  const addButton = form && form.querySelector('button[name="add"]');

  if (form && addButton) {
    const actions = form.querySelector('.product__actions') || addButton.parentElement;

    const trust = document.createElement('ul');
    trust.className = 'nysha-trust';
    trust.innerHTML = `
      <li>
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M12 3l7 3v5c0 4.5-3 8.2-7 10-4-1.8-7-5.5-7-10V6l7-3z"/><path d="M9 12l2 2 4-4"/></svg>
        <span>Certificate &amp; hallmark included</span>
      </li>
      <li>
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg>
        <span>Ships worldwide</span>
      </li>
      <li>
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><rect x="5" y="10" width="14" height="10" rx="2"/><path d="M8 10V7a4 4 0 018 0v3"/></svg>
        <span>Secure payments</span>
      </li>`;
    actions.insertAdjacentElement('afterend', trust);

    const priceEl = document.querySelector('[id^="price-template--"][id$="__main"] .price');

    const bar = document.createElement('div');
    bar.className = 'nysha-sticky-atc';
    bar.hidden = true;
    bar.innerHTML = `<div class="nysha-sticky-atc__price"></div><button type="button" class="nysha-sticky-atc__btn"></button>`;
    document.body.appendChild(bar);

    const barPrice = bar.querySelector('.nysha-sticky-atc__price');
    const barButton = bar.querySelector('.nysha-sticky-atc__btn');

    const sync = () => {
      barButton.textContent = addButton.textContent.trim();
      barButton.disabled = addButton.disabled;
      if (priceEl) barPrice.innerHTML = priceEl.innerHTML;
    };

    sync();
    const observer = new MutationObserver(sync);
    observer.observe(addButton, { childList: true, characterData: true, subtree: true, attributes: true });
    if (priceEl) observer.observe(priceEl, { childList: true, characterData: true, subtree: true });

    barButton.addEventListener('click', () => addButton.click());

    // Size chart: replace the app's fixed side tab with an inline link that opens the same chart
    let tries = 0;
    const waitForSizeTab = setInterval(() => {
      const tab = document.querySelector('[class*="Avada-float-button"]');

      if (tab) {
        clearInterval(waitForSizeTab);

        const link = document.createElement('button');
        link.type = 'button';
        link.className = 'nysha-size-link';
        link.innerHTML =
          '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><rect x="2" y="8" width="20" height="8" rx="1"/><path d="M6 8v3M10 8v4M14 8v3M18 8v4"/></svg> Size chart';
        link.addEventListener('click', () => (tab.querySelector('[role="button"]') || tab).click());
        actions.insertAdjacentElement('beforebegin', link);
        document.body.classList.add('nysha-has-size-link');
      } else if (++tries > 40) {
        clearInterval(waitForSizeTab);
      }
    }, 500);

    // Show the bar once the real add to cart button has scrolled out of view (above the screen)
    let ticking = false;
    const update = () => {
      ticking = false;
      const show = addButton.getBoundingClientRect().bottom < 0;
      bar.hidden = !show;
      document.body.classList.toggle('nysha-sticky-on', show);
    };

    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      },
      { passive: true }
    );
    window.addEventListener('resize', update);
    update();
  }
})();
